<template>
    <Container height="with-footer">
        <div class="container mx-auto py-8 px-4 pt-(--header-height)">
            <h1 class="text-3xl font-bold mb-4">{{ $t("privacy.title") }}</h1>
            <p class="text-sm text-gray-500 mb-6">{{ $t("privacy.last_updated") }} {{ date }}</p>

            <p class="mb-6">{{ $t("privacy.introduction") }}</p>

            <section class="mb-4">
                <h2 class="text-xl font-semibold">{{ $t("privacy.sections.collection.title") }}</h2>
                <p>{{ $t("privacy.sections.collection.content") }}</p>
            </section>

            <section class="mb-4">
                <h2 class="text-xl font-semibold">{{ $t("privacy.sections.use.title") }}</h2>
                <p>{{ $t("privacy.sections.use.content") }}</p>
            </section>

            <section class="mb-4">
                <h2 class="text-xl font-semibold">{{ $t("privacy.sections.sharing.title") }}</h2>
                <p>{{ $t("privacy.sections.sharing.content") }}</p>
            </section>

            <section class="mb-4">
                <h2 class="text-xl font-semibold">{{ $t("privacy.sections.security.title") }}</h2>
                <p>{{ $t("privacy.sections.security.content") }}</p>
            </section>

            <section class="mb-4">
                <h2 class="text-xl font-semibold">{{ $t("privacy.sections.cookies.title") }}</h2>
                <p>{{ $t("privacy.sections.cookies.content") }}</p>
            </section>

            <section class="mb-4">
                <h2 class="text-xl font-semibold">{{ $t("privacy.sections.contact.title") }}</h2>
                <p>{{ $t("privacy.sections.contact.content") }}</p>
            </section>
        </div>
    </Container>
</template>

<script lang="ts" setup>
const date = new Date().toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
</script>

<style></style>
